import { defineMessages } from "react-intl";

export const refundProcessingMessages = defineMessages({
  dialogTitle: {
    defaultMessage: "Processing refund",
    description: "dialog title",
    id: "mMPTtn",
  },
  dialogContent: {
    defaultMessage:
      "Waiting for the payment provider to confirm the refund. This should only take a few seconds.",
    description: "dialog content",
    id: "xbOsjZ",
  },
  refundConfirmed: {
    defaultMessage: "Refund was confirmed by the payment provider",
    description: "notification, refund confirmed",
    id: "Y4XBAK",
  },
  refundPendingConfirmation: {
    defaultMessage:
      "Refund requested — waiting for the payment provider to confirm it. You can still cancel the order, but the refund hasn't been confirmed yet.",
    description: "notification, refund not yet confirmed by the payment provider",
    id: "wTx32L",
  },
  refundFailed: {
    defaultMessage: "The payment provider declined the refund. The order was not cancelled.",
    description: "notification, refund declined by the payment provider",
    id: "YRXRwI",
  },
});
